import Skeleton from '@mui/material/Skeleton'
import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'

const vesselCardLoading = () => {
    return (
        <Card className="h-100 rounded-3 border-0">
            <CardBody className="p-3">
                {/* Image/Top Section */}
                <Skeleton variant="rectangular" width="100%" height={120} className="mb-3" />
                <Row>
                    <Col sm={8}>
                        {/* Title */}
                        <Skeleton variant="text" width="80%" height={20} />
                        {/* Subtitle */}
                        <Skeleton variant="text" width="60%" height={18} className="mb-2" />
                    </Col>
                    <Col sm={4}>
                        {/*badge*/}
                        <Skeleton variant="rectangular" width="100%" height={40} className="mb-3" />
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default vesselCardLoading